(ns ductile.clerk.viewer
  (:require #?@(:clj [[ductile.a-data-readers-loader]
                      [ductile.clerk.doc :as doc]
                      [ductile.datomic.api]]
                :cljs [[nextjournal.clerk :as-alias clerk]])
            [clojure.set :as set]
            [clojure.string :as str]
            [ductile.time.format :as time-format]
            [ductile.ui.locale :as locale :refer [tr get-current-locale]]
            [nextjournal.clerk-table-stats :as table-stats]
            [nextjournal.clerk.viewer :as viewer])
  #?(:cljs (:require-macros [ductile.clerk.viewer :refer [dev-mode?]])))

(def inst->str-viewer
  {:pred #?(:clj #(instance? java.time.Instant %)
            :cljs #(instance? js/Date %))
   :transform-fn (viewer/update-val str)})

(def inst->formatted-str-viewer
  {:pred #?(:clj #(instance? java.time.Instant %)
            :cljs #(instance? js/Date %))
   :transform-fn (comp viewer/mark-presented
                       (viewer/update-val
                        #(time-format/->str {:locale (get-current-locale) :format :datetime :style :short} %)))})

(def zoned-date-time->formatted-str-viewer
  {:pred #?(:clj #(instance? java.time.ZonedDateTime %)
            :cljs #(instance? js/goog.date.DateTime %))
   :transform-fn (comp viewer/mark-presented
                       (viewer/update-val
                        #(time-format/->str {:locale (get-current-locale) :format :datetime :style :short} %)))})

(def uuid->str-viewer
  {:pred uuid?
   :transform-fn (viewer/update-val #(viewer/with-viewer `viewer/tagged-value-viewer
                                       {:tag "uuid" :space? true :value (str %)}))})

(def boolean-table-cell->yes-no-viewer
  "Checks the path to make sure only a table cell matches.
   For table cells the count is 3 because they are nested in a row and a table.
   Boolean values further down the chain (e.g. inside a map) should also be ignored
   to not override the defaults."
  {:pred {:wrapped (fn [{:keys [path] :nextjournal/keys [value]}]
                     (and (= 3 (count path)) (boolean? value)))}
   :transform-fn (fn [{:nextjournal/keys [value]}]
                   (if (true? value) (tr "Yes") (tr "No")))})

(defn namespaced-keyword->str-viewer [ns-str]
  {:pred #(and (keyword? %) (= ns-str (namespace %)))
   :transform-fn #(tr (name (:nextjournal/value %)))})

(def translated-keywords-viewer
  {:pred #(and (keyword? %) (locale/has-translation? %))
   :transform-fn (viewer/update-val tr)})

(def transport-mode->str-viewer
  {:pred #(and (keyword? %) (= "mode" (namespace %)))
   :transform-fn #(tr (:nextjournal/value %))})

(def list-of-strings-viewer
  {:pred #(and (sequential? %) (every? string? %))
   :transform-fn #(str/join ", " (:nextjournal/value %))})

(def set-of-strings-viewer
  {:pred #(and (set? %) (every? string? %))
   :transform-fn #(str/join ", " (:nextjournal/value %))})

(def char-viewer
  {:pred char?
   :transform-fn viewer/mark-presented
   :render-fn (fn [c _opts] (str c))})

(def comments-viewer
  {:pred #(and (sequential? %) (every? :ductile.comment/kind %))
   :transform-fn viewer/mark-presented
   :render-fn '(fn [comments _opts]
                 (into [:div.flex.fle-wrap.gap-2 {:style {:max-width 150}}]
                       (map (fn [{:as comment :ductile.comment/keys [kind]}]
                              (case kind
                                :ductile.comment.kind/image [ductile.ui.mobile/image-tile {:url (str "/cas/" (:cas/multihash comment)) :size 40}]
                                (do (print "Unsupported comment kind in viewer/comments-viewer: " kind)
                                    (str comment)))))
                       comments))})

#_(viewer/with-viewer boolean->polarity-viewer true)

#_(def ductile-table-viewer
    (update
     viewer/table-viewer
     :add-viewers
     viewer/add-viewers
     [(assoc viewer/table-markup-viewer
             :render-fn '(fn [head+body opts]
                           [:div.bg-white.rounded-lg.border.border-slate-300.shadow-sm.font-sans.text-sm.not-prose.overflow-x-auto
                            {:class "print:overflow-none print:text-[10px] print:shadow-none print:rounded-none print:border-none"}
                            (into
                             [:table.w-full]
                             (nextjournal.clerk.render/inspect-children opts)
                             head+body)]))
      (assoc viewer/table-head-viewer
             :render-fn '(fn [header-row {:as opts :keys [path number-col?]}]
                           [:thead
                            (into [:tr.print:border-b-2.print:border-black]
                                  (map-indexed
                                   (fn [i {:as header-cell :nextjournal/keys [value]}]
                                     (let [title (when (or (string? value) (keyword? value) (symbol? value)) value)]
                                       [:th.text-slate-600.text-xs.px-4.py-2.bg-slate-100.first:rounded-md-tl.last:rounded-md-tr
                                        (cond-> {:class (str
                                                         "print:text-[10px] print:bg-transparent print:px-[5px] print:py-[2px] "
                                                         (if (and (ifn? number-col?)
                                                                  (number-col? i))
                                                           "text-right"
                                                           "text-left"))}
                                          title (assoc :title title))
                                        (nextjournal.clerk.render/inspect-presented opts header-cell)])))
                                  header-row)]))
      (assoc viewer/table-row-viewer
             :render-fn '(fn [row {:as opts :keys [path number-col?]}]
                           (into [:tr.print:border-b-gray-500.hover:bg-gray-200.print:hover:bg-transparent
                                  {:class (str "print:border-b-[1px] "
                                               (if (even? (peek path)) "bg-white" "bg-slate-50"))}]
                                 (map-indexed
                                  (fn [idx cell]
                                    [:td.px-4.py-2.text-sm
                                     {:class (str "print:text-[10px] print:bg-transparent print:px-[5px] print:py-[2px] "
                                                  (when (and (ifn? number-col?) (number-col? idx)) "text-right"))}
                                     (nextjournal.clerk.render/inspect-presented opts cell)]))
                                 row)))]))

#?(:clj
   (defmacro dev-mode? []
     (= :dev (:shadow.build/mode &env))))

#?(:cljs (def dev?
           (dev-mode?)))

#?(:clj (def cljs-render doc/cljs-render))


#?(:clj (def entity-viewer
          {:pred (some-fn (partial instance? datomic.query.EntityMap)
                          (partial instance? ductile.datomic.api.EntityMap))
           :transform-fn (viewer/update-val #(into {} %))}))

(def country-code-viewer
  {:pred #(and (map? %) (= 1 (count %)) (viewer/get-safe % :country/code))
   :transform-fn viewer/mark-presented
   :render-fn '(fn [m]
                 (:country/code m))})

(def cardinal-direction-viewer
  {:pred #(and (map? %) (viewer/get-safe % :cardinal-direction/from))
   :transform-fn viewer/mark-presented
   :render-fn 'ductile.clerk.render/cardinal-direction})

(def priority-viewer
  {:pred #(and (map? %) (viewer/get-safe % :priority/date))
   :transform-fn viewer/mark-presented
   :render-fn 'ductile.clerk.render/priority})

(def date-binding-viewer
  {:pred (partial = [:prioritiy/binding-customer-appointment])
   :transform-fn viewer/mark-presented
   :render-fn '(fn [_]
                 [:div.text-center.w-full.text-lg.leading-5 "🤝"])})

(defn tabular-viewer [path & {:as opts}]
  (fn [entity]
    (when-some [value (get-in entity path)]
      (cond->
        {:font (:font opts :tabular)
         :value value}
        (= :right (:align opts))
        (assoc :viewer/css-class "text-right")))))

(defn iso-datetime-viewer [v]
  (when (inst? v)
    [:span.tabular-nums (apply str (take 19 (.toISOString v)))]))

(def location-summary-viewer
  {:pred #(and (map? %) (viewer/get-safe % :location/summary))
   :transform-fn viewer/mark-presented
   :render-fn 'ductile.clerk.render/location-summary})

(def currency-viewer
  {:pred #(and (map? %) (= #{:billing/amount :billing/currency :billing/error} (into #{} (keys %))))
   :transform-fn viewer/mark-presented
   :render-fn '(fn [{:billing/keys [amount currency error]}]
                 [(if error
                    :pre.bg-red-500
                    :pre.text-right)
                  (ductile.util/format-amount amount currency)])})

(def linked-vin-viewer
  {:pred #(and (map? %) (= #{:ductile/id :vehicle/vin} (into #{} (keys %))))
   :transform-fn viewer/mark-presented
   :render-fn '(fn [{ductile-id :ductile/id vin :vehicle/vin}]
                 [ductile.uis/link {:href (str "/vehicle/" ductile-id)}
                  (ductile.uis/vin vin)])})


(def linked-transport-viewer
  {:pred #(and (map? %) (= #{:ductile/id :load/id :compound/name} (into #{} (keys %))))
   :transform-fn viewer/mark-presented
   :render-fn '(fn [{ductile-id :ductile/id load-id :load/id compound-name :compound/name}]
                 [:a.text-nowrap {:href (str "/compound/" compound-name "/transports/" ductile-id)} load-id])})

(def date-format-viewer
  {:pred #(and (map? %)
               (or (inst? (:instant %)) (nil? (:instant %)))
               (#{:date :time :datetime} (:format %)))
   :transform-fn viewer/mark-presented
   :render-fn '(fn [{:as data instant :instant}]
                 (when instant
                   [:span.tabular-nums
                    (ductile.time.format/->str data instant)]))})

(def number-format-viewer
  {:pred #(and (map? %)
               (number? (:number %))
               (number? (:digits %)))
   :transform-fn viewer/mark-presented
   :render-fn '(fn [{:as opts :keys [number digits]}]
                 [:span.inline-block.w-full.tabular-nums.text-right
                  (ductile.ui.locale/format-number (merge {:maximumFractionDigits (or digits 2)
                                                           :minimumFractionDigits (or digits 2)}
                                                          (select-keys opts [:locale]))
                                                   number)])})

(def labels-viewer
  {:pred #(and (map? %) (viewer/get-safe % :labels))
   :transform-fn viewer/mark-presented
   :render-fn 'ductile.ui.components/labels-viewer})

(def font-viewer
  {:pred         #(and (map? %) (viewer/get-safe % :font))
   :transform-fn viewer/mark-presented
   :render-fn    'ductile.clerk.render/font})

(def blocks-viewer
  {:pred (fn [x] (and (vector? x) (every? #(and (qualified-keyword? %)
                                                (= "block" (namespace %))) x)))
   :transform-fn #(viewer/html [:span.text-orange-600.whitespace-nowrap
                                (str/join ", " (map tr (:nextjournal/value %)))])})

(defn deep-merge [& maps]
  (letfn [(m [& xs]
            (if (some #(and (map? %) (not (record? %))) xs)
              (apply merge-with m xs)
              (last xs)))]
    (reduce m maps)))

(defn paths->head [paths]
  (reduce (fn [head p]
            (vec (if (< 1 (count p))
                   (let [lh (last head)
                         k (first p)
                         ks (rest p)]
                     (if (and (vector? lh) (= (first lh) k))
                       (update-in head [(dec (count head)) 1] #(vec (concat % ks)))
                       (conj head [k (vec ks)])))
                   (conj head (first p)))))
          []
          paths))

(comment
  (paths->head [[:fahrzeug/cardinal-direction]
                [:fahrzeug/priority]
                [:transport/origin :address/postcode]
                [:transport/origin :address/street]
                [:transport/destination :location/longitude]
                [:transport/destination :address/country]
                [:vehicle/weight]
                [:transport/origin :address/city]]))

(defn head->paths [head]
  (mapcat (fn [k]
            (if (vector? k)
              (mapv #(vector (first k) %) (last k))
              [[k]])) head))

(defn expand-nested-head [schema head]
  (let [schema-head-by-key (group-by #(if (vector? %) (first %) %) schema)]
    (map (fn [k]
           (if (vector? k)
             (let [ks (second k)]
               [(first k) (vec (concat ks (set/difference (set (get-in schema-head-by-key [(first k) 0 1])) (set ks))))])
             k))
         head)))

(defn ->ordered-paths [ordered-head paths]
  (let [order (head->paths (expand-nested-head (paths->head paths) ordered-head))]
    (->> paths
         (sort-by #(let [i (.indexOf order %)]
                     (if (< i 0) (count paths) i)))
         vec)))

(defn ->visible-paths [hidden paths]
  (reduce (fn [ps p]
            (if (contains? hidden p) ps (vec (conj ps p))))
          []
          paths))

(defn expand-keys-to-head [schema head]
  (let [schema-head-by-key (group-by #(if (vector? %) (first %) %) schema)]
    (mapcat (fn [k]
              (if (vector? k)
                head
                (get schema-head-by-key k)))
            head)))

(def table-markup-viewer
  (assoc viewer/table-markup-viewer
         :render-fn
         '(fn [head+body opts]
            [:div.bg-white.rounded-lg.border.border-slate-300.shadow-sm.font-sans.text-sm.not-prose.overflow-x-auto
             {:class "print:overflow-none print:text-[10px] print:shadow-none print:rounded-none print:border-none"}
             (into
              [:table.w-full]
              (nextjournal.clerk.render/inspect-children opts)
              head+body)])))

(def table-head-viewer
  (assoc viewer/table-head-viewer
         :render-fn '(fn [header-row {:as opts :keys [path number-col?]}]
                       [:thead
                        (into [:tr.print:border-b-2.print:border-black]
                              (map-indexed
                               (fn [i {:as header-cell :nextjournal/keys [value]}]
                                 (let [title (when (or (string? value) (keyword? value) (symbol? value)) value)]
                                   [:th.text-slate-600.text-xs.px-4.py-2.bg-slate-100.first:rounded-md-tl.last:rounded-md-tr
                                    (cond-> {:class (str
                                                     "print:text-[10px] print:bg-transparent print:px-[5px] print:py-[2px] "
                                                     (if (and (ifn? number-col?)
                                                              (number-col? i))
                                                       "text-right"
                                                       "text-left"))}
                                      title (assoc :title title))
                                    (nextjournal.clerk.render/inspect-presented opts header-cell)])))
                              header-row)])))

(def table-body-viewer
  (assoc viewer/table-body-viewer
         :render-fn
         '(fn [rows opts] (into [:tbody] (map-indexed (fn [idx row] (nextjournal.clerk.render/inspect-presented (update opts :path conj idx) row))) rows))))

(def table-row-viewer
  (assoc viewer/table-row-viewer
         :render-fn
         '(fn [row {:as opts :keys [path number-col?]}]
            (into [:tr.print:border-b-gray-500.hover:bg-indigo-50.print:hover:bg-transparent
                   {:class (str "print:border-b-[1px] "
                                (if (even? (peek path)) "bg-white" "bg-slate-50"))}]
                  (map-indexed
                   (fn [idx cell]
                     [:td.px-4.py-2.text-sm.border-r.last:border-r-0
                      {:class (str "print:text-[10px] print:bg-transparent print:px-[5px] print:py-[2px] "
                                   (when (and (ifn? number-col?) (number-col? idx)) "text-right"))}
                      (nextjournal.clerk.render/inspect-presented opts cell)]))
                  row))))

(def ductile-table-viewer
  (-> viewer/table-viewer
      (update :add-viewers viewer/add-viewers [table-markup-viewer
                                               table-body-viewer
                                               table-head-viewer
                                               table-row-viewer])
      (assoc :transform-fn
             (fn [{:as wrapped-value :nextjournal/keys [applied-viewer render-opts]}]
               (if-let [{:keys [head rows]} (table-stats/normalize-table-data render-opts (viewer/->value wrapped-value))]
                 (-> wrapped-value
                     (assoc :nextjournal/viewer `viewer/table-markup-viewer)
                     (update :nextjournal/width #(or % :wide))
                     (update :nextjournal/render-opts merge {:num-cols (count (or head (first rows)))
                                                             :number-col? (into #{}
                                                                                (comp (map-indexed vector)
                                                                                      (keep #(when (number? (second %)) (first %))))
                                                                                (not-empty (first rows)))})
                     (assoc :nextjournal/value (cond->> [(viewer/with-viewer `viewer/table-body-viewer (merge (-> applied-viewer
                                                                                                                  (select-keys [:page-size])
                                                                                                                  (set/rename-keys {:page-size :nextjournal/page-size}))
                                                                                                              (select-keys wrapped-value [:nextjournal/page-size]))
                                                           (if (seq rows)
                                                             (map (partial viewer/with-viewer `viewer/table-row-viewer) rows)
                                                             [(viewer/html [:span.italic "this table has no rows"])]))]
                                                 head (cons (viewer/with-viewer `viewer/table-head-viewer head)))))
                 (-> wrapped-value
                     viewer/mark-presented
                     (assoc :nextjournal/width :wide)
                     (assoc :nextjournal/value [(viewer/present wrapped-value)])
                     (assoc :nextjournal/viewer {:render-fn 'nextjournal.clerk.render/render-table-error})))))))

(def transport-status-viewer
  {:pred #(and (keyword? %) (= "transport.status" (namespace %)))
   :transform-fn viewer/mark-presented
   :render-fn 'ductile.ui.components/transport-status-badge})

(def waypoints-viewer
  {:pred #(and (map? %) (:origin %) (:waypoints %))
   :transform-fn viewer/mark-presented
   :render-fn 'ductile.ui.transport/waypoints-viewer})

(def progress-viewer
  {:pred #(and (map? %) (:done %) (:total %))
   :transform-fn viewer/mark-presented
   :render-fn 'ductile.ui.components/progress-viewer})

#_(viewer/reset-viewers! :default
                         (viewer/add-viewers (viewer/get-default-viewers)
                                             [ductile-table-viewer]))

(def diff-viewer
  {:pred (every-pred map? (some-fn :+ :-))
   :transform-fn viewer/mark-presented
   :render-fn '(fn [v opts]
                 (into [:span.inline-flex.flex-col.border.rounded.overflow-hidden.shadow-sm.border-gray-300
                        {:class (when (> (count (keys v)) 1) ["mb-1"])}]
                       (map (fn [[op mv]]
                              [:span.inline-block
                               [:div.px-1.whitespace-nowrap
                                {:class (case op
                                          :+ ["bg-green-50" "text-green-600"]
                                          :- ["bg-red-50" "text-red-500"])}
                                [:span.text-sm.font-bold.mr-1 (name op)]
                                [nextjournal.clerk.render/inspect mv]]]))
                       v))})

(def render-fn-explain-viewer
  {:pred viewer/render-fn?
   :transform-fn (viewer/update-val :form)
   :render-fn 'ductile.ui.pred-view/explain-pred})

(def render-fn-viewer
  {:pred viewer/render-fn?
   :transform-fn (viewer/update-val :form)})

(def ductile-viewers
  [currency-viewer
   linked-vin-viewer
   linked-transport-viewer
   ductile-table-viewer
   date-format-viewer
   number-format-viewer
   inst->formatted-str-viewer
   zoned-date-time->formatted-str-viewer
   list-of-strings-viewer
   set-of-strings-viewer
   char-viewer
   uuid->str-viewer
   country-code-viewer
   date-binding-viewer
   cardinal-direction-viewer
   priority-viewer
   labels-viewer
   font-viewer
   location-summary-viewer
   blocks-viewer
   transport-status-viewer
   progress-viewer
   waypoints-viewer
   render-fn-viewer
   #?@(:clj [entity-viewer])])

(defn setup-viewers! []
  (viewer/reset-viewers! :default [])
  (viewer/reset-viewers! :default
                         (viewer/add-viewers viewer/default-viewers
                                             ductile-viewers)))

(setup-viewers!)
